import { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";

const HelpSimulationContext = createContext(null);

export function HelpSimulationProvider({ registry, children }) {
  const value = useMemo(
    () => ({
      isActive: true,
      registry: registry || null,
      getHotspot: (helpId) => registry?.hotspots?.[helpId] || null,
    }),
    [registry]
  );

  return (
    <HelpSimulationContext.Provider value={value}>{children}</HelpSimulationContext.Provider>
  );
}

HelpSimulationProvider.propTypes = {
  registry: PropTypes.shape({
    key: PropTypes.string,
    title: PropTypes.string,
    hotspots: PropTypes.object,
  }),
  children: PropTypes.node.isRequired,
};

export function useHelpSimulation() {
  return useContext(HelpSimulationContext);
}

export function useHelpSimulationActive() {
  return Boolean(useHelpSimulation()?.isActive);
}
